import React, { useEffect, useState } from "react";
import Header from "../../components/header";
import { Toaster } from "react-hot-toast";
import UploadSheetFile from '../../UploadSheetFile';  
import { Spin } from "antd";
import "./integrations.css";
import { getIntegrations } from "../../services/integrations";
import { typeFormat } from "../../utils/helpers";
import { useSelector } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleCalendarIntegration from "./GoogleCalendarIntegration";
import GoogleMailIntegration from "./GoogleMailIntegration";
import EmailVerificationIntegration from "./EmailVerificationIntegration";
import ImportGoogleContacts from "../leads/ImportGoogleContacts";
import logger from "../../utils/logger";

interface Integration {
  _id: string;
  key: string;
  name: string;
  description?: string;
  isDisplayable: boolean;
  isActive: boolean;
}
interface IntegrationMessage {
  message: 'facebook' | 'disconnect' | 'connected' | 'popup';
  data?: any;
}
declare global {
  interface Window {
    FB: any;
  }
}


const GOOGLE_CLIENT_ID =
  "322938904388-p7l4fso2n9g93n8irg3c9get69rn3vk4.apps.googleusercontent.com";

const Integrations: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [integrationsList, setIntegrationsList] = useState<any[]>([]);
  const [selectedOption, setSelectedOption] = useState<Integration | null>(
    null
  );
  const [showModal, setShowModal] = useState(false);
  const [integrationMsg, setIntegrationMsg] = useState("");

  const user = useSelector(
    (state: any) => state?.rootReducers?.userData?.userDetails || ""
  );
  logger.log("🔍 DEBUG: localStorage auth_token:", localStorage.getItem("auth_token"));
  logger.log("🔍 DEBUG: All localStorage keys:", Object.keys(localStorage));
  logger.log("🔍 DEBUG: All localStorage:", {...localStorage});

  const token = localStorage.getItem("auth_token") || "";
  logger.log("🔐 DEBUG: Token from localStorage:", token);
  logger.log("🔐 DEBUG: Token type:", typeof token);
  logger.log("🔐 DEBUG: Token length:", token?.length);

// Check BOTH locations
const userFromReducer = useSelector((state: any) => state?.rootReducers?.userData?.userDetails);
const userFromSlice = useSelector((state: any) => state?.whatsapp?.user);

logger.log("🔧 REDUCER - userData.userDetails:", userFromReducer);
logger.log("🍕 SLICE - whatsapp.user:", userFromSlice);
logger.log("🔧 REDUCER token:", userFromReducer?.token);
logger.log("🍕 SLICE token:", userFromSlice?.token);
  

const fullReduxState = useSelector((state: any) => state);
logger.log("🔍 DEBUG: FULL Redux State:", fullReduxState);
logger.log("🔍 DEBUG: rootReducers structure:", fullReduxState?.rootReducers);
logger.log("🔍 DEBUG: auth section:", fullReduxState?.rootReducers?.auth);
logger.log("🔍 DEBUG: userData section:", fullReduxState?.rootReducers?.userData);

logger.log("🔐 DEBUG: User object from Redux:", user);
logger.log("🔐 DEBUG: Token being passed:", user?.token);
  const systemIntegrations = useSelector(
    (state: any) =>
      state?.rootReducers?.userData?.userDetails?.systemIntegration?.filter(
        (_i: { isDisplayable: boolean; isActive: boolean; name: string }) =>
          _i.isDisplayable && _i.isActive && _i.name !== "Whatsapp Business"
      ) || []
  );

  const getIntegrationDescription = (key: string) => {
    switch (key) {
      case "justdial":
        return "Connect JustDial to import lnquiries from Justdial";
      case "99acres":
        return "Automatically Import property leads from 99Acres";
      case "indiamart":
        return "Get business leads and inquiries from Indiamart directly";
      case "wordpress":
        return "Sync your Wordpress leads automatically";
      case "tradeindia":
        return "Import business leads from TradeIndia to your CRM";
      case "facebook":
        return "Connect Facebook/instagram leads from leadforms automatically";
      case "housing":
        return "Get real estate leads from Housing.com automatically";
      case "magicbricks":
        return "Import property inquiries from MagicBricks directly";
      case "zapier":
        return "Connect your Zapier workflows adn create leads automatically";
      case "google_lead_form":
        return "Automatically import leads from Google Forms";
      case "exporters_india":
        return "Import business leads from Exporters India marketplace";
      case "razorpay":
        return "Collect Payments directly from 3sigma Forms";
      case "brevo":
        return "Streamline your email marketing campaigns";
      case "pabbly":
        return "Connect 3sigma with pabbly";
        case "facebook_audience":
  return "Allows users to sync their CRM leads and create automated audience on FB ads accounts to target";
      case "email_verification":
        return "Validate email addresses before campaigns to boost deliverability and maximize inbox placement";
      case "three_sigma_webhook":
        return "Create custom webhooks to receive leads from any external source";
      case "zeptomail":
        return "Send transactional emails reliably with ZeptoMail's powerful email API";
      case "caller_desk":
        return "Virtual telephony platform - Manage calls and create leads automatically";
      case "acefone":
        return "Virtual telephony solution - Capture call details and sync leads seamlessly";
      case "my_operator":
        return "Cloud telephony service - Track calls and import leads from phone conversations";
      default:
        return "Connect to enhance your workflow";
    }
  };

  const allIntegrations = [
    ...systemIntegrations.map((integration: { key: string }) => ({
      ...integration,
      description: getIntegrationDescription(integration.key),
    })),
    {
      _id: "google_calendar",
      key: "google_calendar",
      name: "Google Calendar",
      description: "Sync your calendar events and manage meetings",
      isDisplayable: true,
      isActive: true,
    },
   
    {
      _id: "google_mail",
      key: "google_mail",
      name: "Gmail",
      description: "Connect Gmail to manage email communications",
      isDisplayable: true,
      isActive: true,
    }
    /*,
    {
      _id: "google_sheets",
      key: "google_sheets",
      name: "Google Sheets",
      description: "Import and sync your leads directly from Google Sheets",
      isDisplayable: true,
      isActive: true,
    }*/,
    {
      _id: "google_contacts",
      key: "google_contacts",
      name: "Google Contacts",
      description: "Import and sync leads from your Google Contacts",
      isDisplayable: true,
      isActive: true,
    },
    {
      _id: "email_verification",
      key: "email_verification",
      name: "Email Verification",
      description: "Validate email addresses before campaigns to boost deliverability and maximize inbox placement",
      isDisplayable: true,
      isActive: true,
    }
  ];

  useEffect(() => {
    fetchIntegrations();
  }, []);


useEffect(() => {
  const handleMessage = (event: MessageEvent) => {
    if (event.origin !== 'https://integration.3sigmacrm.com') return;

    



    // Handle other integration messages
    if (event.data.message === 'connected' || event.data.message === 'disconnect') {
      setShowModal(false);
      fetchIntegrations();
      setIntegrationMsg(
        event.data.message === 'connected' 
          ? "Integration connected successfully"
          : "Integration disconnected successfully"
      );
    }
  };

  window.addEventListener('message', handleMessage);
  return () => window.removeEventListener('message', handleMessage);
}, [selectedOption, user]);

useEffect(() => {
  if (integrationMsg) {
    const timer = setTimeout(() => {
      setIntegrationMsg("");
    }, 5000); // Clear message after 5 seconds

    return () => clearTimeout(timer);
  }
}, [integrationMsg]);

  const fetchIntegrations = async () => {
    setLoading(true);
    try {
      const { data } = await getIntegrations();
      setIntegrationsList(data?.data?.length ? data.data : []);
    } catch (error) {
      logger.error("Failed to fetch integrations:", error);
    }
    setLoading(false);
  };

  return (
    <div className="integrations-container">
      <Header />
      <div className="page-header">
        <h1 className="page-title">Integrations</h1>
        <p className="page-subtitle">Connect your favorite tools and automate lead capture from multiple sources</p>
      </div>
      <div className="integrations-grid">
        {allIntegrations.map((item: Integration) => {
          const isConnected = integrationsList?.find(
            (i) => i.integrationId === item._id
          );
          const hasError = isConnected?.details?.errorMessage;

          return (
            <div key={item._id} className="integration-card">
              <div className="integration-header">
                <div className="integration-info">
                {item.key === "google_calendar" ||
item.key === "google_mail" ||
item.key === "google_contacts" ||
item.key === "google_sheets" ||
item.key === "caller_desk" ||
item.key === "acefone" ||
item.key === "exporters_india" ||
item.key === "my_operator" ? (
  <img
    src={
      item.key === "google_calendar"
        ? require("../../assets/images/integration/googlecalender.png")
        : item.key === "google_mail"
        ? require("../../assets/images/integration/gmail.png")
        : item.key === "google_sheets"
        ? require("../../assets/images/integration/googlesheets.png")
        : item.key === "google_contacts"
        ? require("../../assets/images/integration/googlecontacts.png")
        : item.key === "caller_desk"
        ? `${process.env.PUBLIC_URL}/assets/img/caller_logo.svg`
        : item.key === "acefone"
        ? `${process.env.PUBLIC_URL}/assets/img/acefonelogo.svg`
        : item.key === "exporters_india"
        ? `${process.env.PUBLIC_URL}/assets/img/exporterindia.jfif`
        : `${process.env.PUBLIC_URL}/assets/img/myoperatorlogo.png`
    }
    className="integration-icon"
    alt={item.name}
  />
                  ) : (
                    <span className="integration-icon">
                      {typeFormat(item?.key).icon}
                    </span>
                  )}
                  <span className="integration-name">{item.name}</span>
                </div>
                {isConnected && !hasError && <span className="check-icon">✓</span>}
                {hasError && <span className="check-icon" style={{ color: '#ff4d4f' }}>⚠</span>}
              </div>

              <p className="integration-desc">{item.description}</p>

              {hasError && (
                <div style={{
                  fontSize: '12px',
                  color: '#ff4d4f',
                  marginBottom: '10px',
                  padding: '8px',
                  backgroundColor: '#fff2f0',
                  borderRadius: '4px',
                  border: '1px solid #ffccc7'
                }}>
                  <strong>Error:</strong> {isConnected.details.errorMessage}
                </div>
              )}

              <button
                className={`connect-button ${isConnected ? "manage" : ""}`}
                onClick={() => {
                  setSelectedOption(item);
                  setShowModal(true);
                }}
              >
                {isConnected ? "Manage" : "Connect"}
              </button>
            </div>
          );
        })}
      </div>
  
      {showModal && (
  <div className="modal-overlay" onClick={() => setShowModal(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        {selectedOption?.key === "google_mail" && (
          <GoogleMailIntegration
            userId={user?._id}
            onSuccess={() => {
              setIntegrationMsg("Gmail connected successfully");
              fetchIntegrations();
              setShowModal(false);
            }}
            onError={(error) => {
              setIntegrationMsg(`Failed to connect Gmail: ${error}`);
            }}
          />
        )}
        {selectedOption?.key === "google_calendar" && (
          <GoogleCalendarIntegration
            userId={user?._id}
            onSuccess={() => {
              setIntegrationMsg("Calendar connected successfully");
              fetchIntegrations();
              setShowModal(false);
            }}
            onError={(error) => {
              setIntegrationMsg(`Failed to connect calendar: ${error}`);
            }}
          />
        )}
        {selectedOption?.key === "google_contacts" && (
          <ImportGoogleContacts
            selectedList={{ id: "", name: "" }}
          />
        )}
        {selectedOption?.key === "google_sheets" && (
          <UploadSheetFile
            selectedList={{ id: "", name: "" }}
          />
        )}
        {selectedOption?.key === "email_verification" && (
          <EmailVerificationIntegration
            userId={user?._id}
            onSuccess={() => {
              setIntegrationMsg("Email verification connected successfully");
              fetchIntegrations();
              setShowModal(false);
            }}
            onError={(error) => {
              setIntegrationMsg(`Failed to connect email verification: ${error}`);
            }}
          />
        )}
     {selectedOption &&
  !["google_mail", "google_calendar", "google_contacts", "google_sheets", "email_verification"].includes(
    selectedOption.key
  ) && (
    (() => {
      const iframeUrl = `https://integration.3sigmacrm.com/integration/${
        selectedOption.key === 'exporters_india' ? 'exporter_india' : 
        selectedOption.key === 'facebook_audience' ? 'fbaudience' : 
        selectedOption.key
      }/${user?._id}?token=${token?.slice(7)}`;
      
      logger.log("🔥 IFRAME DEBUG - ABOUT TO RENDER");
      logger.log("🔥 Raw localStorage:", localStorage.getItem("auth_token"));
      logger.log("🔥 token variable:", token);
      logger.log("🔥 token?.slice(7):", token?.slice(7));
      logger.log("🔥 user?._id:", user?._id);
      logger.log("🔥 selectedOption.key:", selectedOption.key);
      logger.log("🔥 COMPLETE IFRAME URL:", iframeUrl);
      
      return (
        <iframe
          style={{ width: "100%", height: "500px", border: "none" }}
          src={iframeUrl}
          onLoad={() => logger.log("🔥 IFRAME LOADED")}
        />
      );
    })()
  )}
      </GoogleOAuthProvider>
    </div>
  </div>
)}
  
      {integrationMsg && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <strong>{integrationMsg}</strong>
        </div>
      )}
  
      <Toaster position="top-right" reverseOrder={false} />
    </div>
  );
};

export default Integrations;